import { useQuery } from "@tanstack/react-query"
import { KNOWMIX } from "../../../library/store/actions/types/knowmixTypes"

export const useKnowmixStep = ({ knowmixId, stepId }, options = {}) => {
  const { data, ...rest } = useQuery({
    queryKey: [KNOWMIX.STEPS.LIST, { id: knowmixId }],
    refetchOnFocus: false,
    ...options,
  })

  return {
    step: data?.steps?.find((s) => s.id === stepId),
    queryKey: [KNOWMIX.STEPS.LIST, { id: knowmixId }],
    ...rest,
  }
}
